/* eslint-disable tailwindcss/no-arbitrary-value */
import { MaterialIcon } from '@hyphengroup/cms-components/components/MaterialIcon';
import { useCopyWithFeedback } from '@hyphengroup/cms-components/hooks/useCopyWithFeedback';
import { FC } from 'react';
import { tr } from '$/components/cms/helpers';

type FlexibleHeroBlockStkBkaPromoCodeProps = {
  promoCode: string;
  lang: string;
};

/** The product's promo code in the side card's header row, with copy. */
export const FlexibleHeroBlockStkBkaPromoCode: FC<
  FlexibleHeroBlockStkBkaPromoCodeProps
> = ({ promoCode, lang }) => {
  const { isCopied, copy } = useCopyWithFeedback();

  return (
    <div
      className="relative ml-auto flex flex-col items-end gap-1"
      data-component="flexible-hero-block-stk-bka-promo-code"
    >
      <span className="mhg-alpha-typography-badge text-right uppercase text-secondary-lighter">
        {tr('promo_code', lang)}
      </span>
      <div className="flex items-center gap-[6px] rounded-[6px] border-[1.5px] border-dashed border-fill/primary px-3 py-[6px] bg-fill/primary-light">
        <span className="mhg-alpha-typography-tag text-fill/primary">
          {promoCode}
        </span>
        <button
          type="button"
          aria-label="Copy promo code"
          className="flex items-center justify-center text-fill/primary"
          onClick={() => copy(promoCode)}
        >
          {/* The glyph takes the button's colour (currentColor); the shared
            ContentCopy SVG has its grey fill baked in. */}
          <MaterialIcon icon="content_copy" px={18} />
        </button>
      </div>
      {/* Always mounted, so screen readers announce the confirmation when it appears. */}
      <span role="status" className="absolute right-0 top-full mt-1">
        {isCopied && (
          <span className="mhg-alpha-typography-caption block rounded-radius/button px-2 py-1 shadow-md bg-fill/card text-secondary-lighter">
            {tr('copied', lang)}
          </span>
        )}
      </span>
    </div>
  );
};
